module.exports = __webpack_public_path__ + "static/media/flowers_featured.adf48b0d.jpg";